import { render } from "./PurchasePaymentReportPage.vue?vue&type=template&id=2cbc4b96&scoped=true&ts=true"
import script from "./PurchasePaymentReportPage.vue?vue&type=script&lang=ts"
export * from "./PurchasePaymentReportPage.vue?vue&type=script&lang=ts"

import "./PurchasePaymentReportPage.vue?vue&type=style&index=0&id=2cbc4b96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbc4b96"]])

export default __exports__